import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react'
import { Button } from '@/components/ui'
import { format, addWeeks, subWeeks, startOfWeek, endOfWeek } from 'date-fns'
import { de } from 'date-fns/locale'

interface DispositionCalendarHeaderProps {
  from: Date
  to: Date
  onNavigate: (from: Date, to: Date) => void
}

export function DispositionCalendarHeader({ from, to, onNavigate }: DispositionCalendarHeaderProps) {
  function goBack() {
    const newFrom = startOfWeek(subWeeks(from, 1), { weekStartsOn: 1 })
    const newTo = endOfWeek(newFrom, { weekStartsOn: 1 })
    onNavigate(newFrom, newTo)
  }

  function goForward() {
    const newFrom = startOfWeek(addWeeks(from, 1), { weekStartsOn: 1 })
    const newTo = endOfWeek(newFrom, { weekStartsOn: 1 })
    onNavigate(newFrom, newTo)
  }

  function goToday() {
    const today = new Date()
    const newFrom = startOfWeek(today, { weekStartsOn: 1 })
    const newTo = endOfWeek(newFrom, { weekStartsOn: 1 })
    onNavigate(newFrom, newTo)
  }

  const weekLabel = `${format(from, 'd. MMM', { locale: de })} – ${format(to, 'd. MMM yyyy', { locale: de })}`

  return (
    <div className="flex items-center gap-2">
      <Button variant="secondary" size="sm" onClick={goBack} aria-label="Vorherige Woche">
        <ChevronLeft className="w-4 h-4" />
      </Button>
      <Button variant="secondary" size="sm" onClick={goToday}>
        <Calendar className="w-4 h-4 mr-1.5" />
        Heute
      </Button>
      <Button variant="secondary" size="sm" onClick={goForward} aria-label="Nächste Woche">
        <ChevronRight className="w-4 h-4" />
      </Button>
      <span className="text-sm font-medium text-gray-700 ml-1">{weekLabel}</span>
    </div>
  )
}
